import styled from "@emotion/styled"
import { css } from '@emotion/react'

const inputSize = ({ size }) => {
  if (size === 600) {
    return css({
      minHeight: 48,
      padding: "10px 12px",
      borderRadius: 10,
    })
  } else
  if (size === 500) {
    return css({
      padding: "10px 12px",
      borderRadius: 8,
    })
  } else
  if (size === 400) {
    return css({
      padding: "6px 8px",
      borderRadius: 6,
    })
  }
}

const inputColor = ({ isError }) => {
  if (!isError) {
    return css({
      boxShadow: "0 0 0 2px transparent, inset 0 0 0 1px var(--color-grayscale-100)",

      "&:hover": {
        boxShadow: "0 0 0 2px transparent, inset 0 0 0 1px var(--color-grayscale-100), var(--elevation-light-low-primary)",
      },

      "&:focus": {
        boxShadow: "0 0 0 2px var(--color-grayscale-900), inset 0 0 0 1px transparent",
      }
    })
  } else {
    return css({
      boxShadow: "0 0 0 2px transparent, inset 0 0 0 1px var(--color-destruction-300)",

      "&:hover": {
        boxShadow: "0 0 0 2px transparent, inset 0 0 0 1px var(--color-destruction-300), var(--elevation-light-low-primary)",
      },

      "&:focus": {
        boxShadow: "0 0 0 2px var(--color-destruction-400), inset 0 0 0 1px transparent",
      }
    })
  }
}

export const Input = styled.input`
  width: 100%;
  color: var(--_color-900);
  outline: none;
  resize: none;
  transition: box-shadow var(--transition);

  &:disabled {
    cursor: not-allowed;
  }
  ${inputSize}
  ${inputColor}
`
